import React from 'react';
import MIcon from './MIcon';

const ICONS = {
  'image/jpeg': 'image', 'image/png': 'image', 'image/gif': 'image', 'image/webp': 'image',
  'application/pdf': 'picture_as_pdf',
  'application/msword': 'description',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'description',
  'text/plain': 'article',
};

function fmtSize(b) {
  if (b < 1024) return b + ' B';
  if (b < 1024*1024) return (b/1024).toFixed(0) + ' KB';
  return (b/(1024*1024)).toFixed(1) + ' MB';
}

export default function AttachGallery({ attachments }) {
  if (!attachments?.length) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
      {attachments.map(a => {
        const isImg = a.mime_type?.startsWith('image/');
        const icon  = ICONS[a.mime_type] || 'insert_drive_file';
        const url   = `/uploads/${a.filename}`;
        return (
          <a key={a.id} href={url} target="_blank" rel="noreferrer"
            title={a.original_name}
            style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 7,
              padding: '5px 10px 5px 6px', borderRadius: 8,
              border: '1px solid #C5D8E8', background: '#F8FBFD',
              maxWidth: 210, transition: 'border-color .12s' }}
            onMouseOver={e => e.currentTarget.style.borderColor='var(--una-blue)'}
            onMouseOut={e => e.currentTarget.style.borderColor='#C5D8E8'}>
            {isImg
              ? <img src={url} alt="" style={{ width: 28, height: 28, borderRadius: 4, objectFit: 'cover', flexShrink: 0 }}/>
              : <div style={{ width: 28, height: 28, borderRadius: 4, background: '#E0EEF7', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <MIcon name={icon} size={16} style={{ color: 'var(--una-blue)' }}/>
                </div>
            }
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {a.original_name}
              </div>
              <div style={{ fontSize: 10, color: '#9CA3AF' }}>{fmtSize(a.size)}</div>
            </div>
            <MIcon name="open_in_new" size={12} style={{ color: '#9CA3AF', flexShrink: 0, marginLeft: 2 }}/>
          </a>
        );
      })}
    </div>
  );
}
